import React from 'react';
import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import Currency from '../Currency';

import useDeviceResize from '../../hooks/useDeviceResize';

const ContractRiskAmount = ({
  amount,
  isFetchingPrice,
  classes,
  infoTitle,
}) => {
  const isDeviceMdSize = useDeviceResize('md');

  return (
    <Grid
      container
      className={classes.priceSection}
      alignItems="center"
      justifyContent="center"
      alignContent="center"
      direction="row-reverse"
    >
      <Grid
        item
        className={classes.amountWrapper}
        style={{
          paddingRight: isDeviceMdSize ? 10 : 0,
          textAlign: isDeviceMdSize ? 'right' : 'center',
        }}
        md={12}
        xs={6}
      >
        <Currency value={amount} isFetching={isFetchingPrice} placeholder="-" withSymbol />
      </Grid>
      <Grid className={classes.textWrapper} item md={12} xs={6}>
        <span
          style={{
            paddingLeft: isDeviceMdSize ? 10 : 0,
            textAlign: isDeviceMdSize ? 'justify' : 'center',
          }}
          className={classes.text}
        >
          {infoTitle}
        </span>
      </Grid>
    </Grid>
  );
};

ContractRiskAmount.propTypes = {
  amount: PropTypes.number.isRequired,
  infoTitle: PropTypes.string.isRequired,
  isFetchingPrice: PropTypes.bool.isRequired,
  classes: PropTypes.shape({
    priceSection: PropTypes.string.isRequired,
    amountWrapper: PropTypes.string.isRequired,
    textWrapper: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }).isRequired,
};

export default ContractRiskAmount;
